import { render, staticRenderFns } from "./vsCol.vue?vue&type=template&id=ba350050&lang=html"
import script from "./vsCol.vue?vue&type=script&lang=js"
export * from "./vsCol.vue?vue&type=script&lang=js"
import style0 from "./vsCol.vue?vue&type=style&index=0&id=ba350050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports